/**
 * Validates browser storage (cookies and localStorage) and displays warning if unavailable.
 */
export default function cookieCheck() {
  if (!navigator.cookieEnabled || !isLocalStorageAvailable()) {
    document.querySelector('#no-cookies-warning').classList.remove('hide');
  }

  /**
   * Checks if localStorage is available and accessible in the current browser context.
   *
   * @returns {boolean} true if localStorage is available and writable, false otherwise
   */
  function isLocalStorageAvailable() {
    try {
      const test = '__localStorage_test__';

      localStorage.setItem(test, test);
      localStorage.removeItem(test);

      return true;
    } catch (e) {
      return false;
    }
  }
}
